import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, NgModel } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-finance-list',
  templateUrl: './finance-list.component.html',
  styleUrls: ['./finance-list.component.css']
})
export class FinanceListComponent implements OnInit {
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  zone: any;
  supcode: any;
  Actiocmg: UntypedFormGroup;

  constructor(
    private auth: Authenticationservice
    , private spinner: NgxSpinnerService
    , private fb: UntypedFormBuilder
  ) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlv = userdata.userlevel

    this.Actiocmg = this.fb.group({
      selecyear: '',
      selectzone: '',
      date1: '',
      date2: '',
      doc_status: '',
      fmcode: ''
    })
  }
  displaylist = ['no', 'doc_no', 'supportter', 'date', 'FMCODE', 'intlandno', 'fullname', 'comment1', 'countmoney', 'credit_approved', 'dateapprove', 'datetransfer', 'bank', 'status', 'timeline'];

  ngOnInit(): void {
    this.selecyear = '6678'
    this.LoadZone()
  }
  selecyear: string;
  userlv = ''
  zonecode;

  LoadZone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url).then(res => {
      this.zonecode = (res.data.recordset);
    }).catch(err => { throw (err) })
  }

  applyFilter(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.listdata.filter = filterValue2.trim().toLowerCase();;
    if (this.listdata.paginator) {
      this.listdata.paginator.firstPage();
    }
  }
  setselect = 1;
  // โหลดข้อมูล
  listdata: any;
  listdatadata = [];
  Loadlistaskformoney() {
    this.spinner.show();
    let fdata = this.Actiocmg.value;
    let status = fdata.doc_status;
    let fmcode = fdata.fmcode;
    let sdate1 = fdata.date1, sdate2 = fdata.date2, szone = fdata.selectzone;
    let url = '', url0 = '', status_t = '';
    let sselect = this.setselect

    if (status == 10) { status_t = "and[doc_status]<>'X'"; }
    else { status_t = "and[doc_status]='" + status + "'"; }
    url0 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/api_tast2/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_getfinance]";
    /*
    url1 = "&w=[YearID]='"+ this.selecyear +"' and[supzone]='"+szone+"' "+status_t;
    url2 = "&w=[YearID]='"+ this.selecyear +"' and[doc_status]='4' and cast([dateapprove] as date) between'"+sdate[0]+"'and '"+sdate[1]+"'";
    url3 = "&w=[YearID]='"+ this.selecyear +"' "+status_t+" and cast([datepost] as date) between'"+sdate[0]+"'and '"+sdate[1]+"'";
    url4 = "&w=[YearID]='"+ this.selecyear +"' and[FMCODE]='"+fmcode+"'";
    */
    if (sselect == 1) url = url0 + "&w=[YearID]='" + this.selecyear + "' and[supzone]='" + szone + "' " + status_t;
    else if (sselect == 2) url = url0 + "&w=[YearID]='" + this.selecyear + "' and[doc_status]='4' and cast([dateapprove] as date) between'" + sdate1 + "'and '" + sdate2 + "'";
    else if (sselect == 3) url = url0 + "&w=[YearID]='" + this.selecyear + "' " + status_t + " and cast([datepost] as date) between'" + sdate1 + "'and '" + sdate2 + "'";
    else if (sselect == 4) url = url0 + "&w=[YearID]='" + this.selecyear + "' and[FMCODE]='" + fmcode + "'";
    //
    console.log('szone', szone, '/', 'sdate', sdate1, sdate2, '/', 'fdata', fdata, '/', 'sselect', sselect);

    axios.get(url).then(res => {
      if (res.data.length >= 1) {
        this.spinner.hide();
        let data = (res.data);
        this.listdatadata = data;
        data.sort((a, b) => {
          return new Date(b.dateapprove).getTime() - new Date(a.dateapprove).getTime();
        });
        this.listdata = new MatTableDataSource(data);
        this.paginator.length = data.length;
        this.paginator.pageSize = 10;
        this.listdata.sort = this.sort;
        this.listdata.paginator = this.paginator;
      }
      this.spinner.hide();
    }).catch(err => { throw (err) })
  }

  ExportTOExcel() {
    let options: any = {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"
    };
    var currentDate = new Date();
    var dateLOC = currentDate.toLocaleString('th-TH', options);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    /* save to file */
    XLSX.writeFile(wb, 'ข้อมูลการเบิกปัจจัย_' + dateLOC + '.xlsx');
    console.log('currentDate', currentDate);
    console.log('dateLOC', dateLOC);
  }

  select_data() {
    let szone = this.Actiocmg.value.selectzone;
    let syear = this.selecyear;
    if (szone != null && syear != null) this.Loadlistaskformoney();
    console.log('syear:', syear, ' | ', 'szone:', szone);
  }

  THtoLocalstring(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  THtoLocalstring2(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

}
